import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import $ from "jquery";
import "jquery-validation";
import BASE_URL from "../config"; // ✅ Import BASE_URL

const AddUser = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    personal_email: "",
    password: "",
    phone: "",
    address: "",
    bio: "",
    image_url: "",
    role: "user",
    status: "active",
    emergency_phone: "",
    emergency_person_name: "",
    emergency_person_relation: "",
    facebook_link: "",
    linkedIn_link: "",
  });

  // Apply jQuery Validation on component mount
  useEffect(() => {
    $("#userForm").validate({
      rules: {
        username: "required",
        bio: "required",
        facebook_link: "required",
        linkedIn_link: "required",
        image_url: "required",
        email: {
            required: true,
            email: true
        },
        personal_email: {
            required: true,
            email: true
        },
        phone: {
            required: true,
           
            minlength: 10,
            maxlength: 12
        },
        address: "required",
        emergency_phone: {
          required: true,
           
            minlength: 10,
            maxlength: 12
        },
       
        emergency_person_name: "required",
        emergency_person_relation: "required",
    },
    messages: {
        username: "Please enter a name",
        bio: "Please enter a bio",
        facebook_link: "Please enter a Facebook Link",
        linkedIn_link: "Please enter a LinkedIn Link",
        image_url: "Please enter a Profile URL",
        email: {
            required: "Please enter an email",
            email: "Enter a valid email"
        },
        personal_email: {
            required: "Please enter a personal email",
            email: "Enter a valid email"
        },
        phone: {
            required: "Please enter a phone number",
           
            minlength: "Must be at least 10 digits",
            maxlength: "Cannot exceed 12 digits"
        },
        address: "Please enter an address",
        emergency_phone: {
          required: "Please enter an Emergency phone",
            minlength: "Must be at least 10 digits",
            maxlength: "Cannot exceed 12 digits"
        },
        emergency_person_name: "Please enter emergency contact name",
        emergency_person_relation: "Please enter emergency contact relation",
    },
      errorClass: "text-danger",
      errorElement: "small",
      highlight: function (element) {
        $(element).addClass("is-invalid");
      },
      unhighlight: function (element) {
        $(element).removeClass("is-invalid");
      },
    });
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!$("#userForm").valid()) return; // Prevent submission if form is invalid

    try {
      const userData = {
        ...formData,
        date_created: new Date().toISOString().split("T")[0],
      };

      await axios.post(`${BASE_URL}api/user/add`, userData); // ✅ Use BASE_URL

      Swal.fire({
        icon: "success",
        title: "User Added!",
        text: "The user has been successfully created.",
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        navigate("/users");
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to add user. Please try again.",
      });
      console.error("Error:", error);
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="text-center text-primary">Add User</h2>
      <form id="userForm" onSubmit={handleSubmit} className="p-4 border rounded shadow">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Username</label>
            <input type="text" name="username" className="form-control" value={formData.username} onChange={handleChange} required />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Email</label>
            <input type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} required />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Personal Email</label>
            <input type="email" name="personal_email" className="form-control" value={formData.personal_email} onChange={handleChange} />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Password</label>
            <input type="password" name="password" className="form-control" value={formData.password} onChange={handleChange} required />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Phone</label>
            <input type="text" name="phone" className="form-control" value={formData.phone} onChange={handleChange} />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Profile Image URL</label>
            <input type="text" name="image_url" className="form-control" value={formData.image_url} onChange={handleChange} />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Address</label>
          <textarea name="address" className="form-control" value={formData.address} onChange={handleChange}></textarea>
        </div>

        <div className="mb-3">
          <label className="form-label">Bio</label>
          <textarea name="bio" className="form-control" value={formData.bio} onChange={handleChange}></textarea>
        </div>

        <h5 className="text-secondary">Emergency Contact</h5>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Emergency Phone</label>
            <input type="text" name="emergency_phone" className="form-control" value={formData.emergency_phone} onChange={handleChange} />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Emergency Contact Name</label>
            <input type="text" name="emergency_person_name" className="form-control" value={formData.emergency_person_name} onChange={handleChange} />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Relation</label>
          <input type="text" name="emergency_person_relation" className="form-control" value={formData.emergency_person_relation} onChange={handleChange} />
        </div>

        <h5 className="text-secondary">Social Media</h5>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Facebook Profile Link</label>
            <input type="text" name="facebook_link" className="form-control" value={formData.facebook_link} onChange={handleChange} />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">LinkedIn Profile Link</label>
            <input type="text" name="linkedIn_link" className="form-control" value={formData.linkedIn_link} onChange={handleChange} />
          </div>
        </div>

        <button type="submit" className="btn btn-primary me-2">Add User</button>
        <a href="/users" className="btn btn-secondary ms-2">Cancel</a>
      </form>
    </div>
  );
};

export default AddUser;
